"use strict";

exports.__esModule = true;
exports.useForm = useForm;

var _hooks = require("@bydesign-ui/hooks");

var _form = require("../../hooks/form");

function useForm(options) {
  return (0, _hooks.useSingleton)(function () {
    return new _form.Form(options || {});
  });
}